import { Route } from 'react-router-dom';
import { acvfDuMoisViewSchema } from './acvfDuMois';
import Main from '@app/main/tables/Main';

/**
 * Routes configurées pour le module BallonsDueToClub
 */
const ACVFDuMoisRoutes = [
    // Route de liste (principale)
    <Route
        key="acvf-du-mois"
        path="acvfDuMois"
        element={
            <Main key="acvf-du-mois-main" pageConfig={acvfDuMoisViewSchema} />
        }
    />,
];

export default ACVFDuMoisRoutes;
